// src/components/ui/AppBackdrop.jsx
//
// El fondo de las vistas que cuelgan del rail: negro con un halo morado arriba a
// la izquierda. Estaba escrito a mano dentro de AIDashboard, así que las
// pantallas que se añadieron después —Support, las tarifas— salieron en negro
// plano y se notaba el corte al cambiar de una a otra.
//
// Es decorativo y no debe capturar clics ni entrar en el orden de lectura.
import React from "react";

/**
 * @param {boolean} [withBase]  pinta el negro de base. Quien ya lo tenga en su
 *   raíz lo pasa en `false` para no superponer dos capas del mismo color.
 */
export default function AppBackdrop({ withBase = true }) {
  return (
    <>
      {withBase && <div aria-hidden="true" className="absolute inset-0 bg-black" />}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute rounded-full"
        style={{
          top: "1rem",
          left: "4rem",
          width: "33rem",
          height: "33rem",
          background:
            "radial-gradient(circle at 25% 25%, rgba(75,0,130,0.8) 0%, rgba(75,0,130,0.4) 50%, transparent 90%)",
          filter: "blur(140px)",
        }}
      />
    </>
  );
}
